import React, { useMemo } from 'react';
import DataByDayTable from '../metrics/DataByDayTable';
import parse from 'date-fns/parse'

const TableContainer = ({data}) => {
  const dataToTableRow = (elt) => ({
    ...elt,
    date: parse(elt.date, 'yyyy-MM-dd', new Date()),
    opt_in: elt.location_authorized_devices/elt.active_devices,
    consent: elt.consented_devices/elt.active_devices,
    geolocated_devices_consented: elt.loc_consented_devices/elt.location_authorized_devices,
    global_opt_in: elt.loc_consented_devices/elt.active_devices
  })
  const tableData = useMemo(()=>{
    return data.map((row) => (dataToTableRow(row)))
  }, [data])

  return (
    <DataByDayTable data={tableData} />
  )
}

export default TableContainer